// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
}

.input-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #cccccc;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.input-required {
  color: #ff4444;
  font-weight: 600;
}

.input-field {
  padding: 0.75rem 1rem;
  border: 2px solid #444444;
  border-radius: 0.5rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #ffffff;
  background-color: #2a2a2a;
  transition: all 0.2s ease-in-out;
  width: 100%;
  box-sizing: border-box;
}

.input-field::placeholder {
  color: #888888;
}

.input-field:focus {
  outline: none;
  border-color: #00ff88;
  box-shadow: 0 0 0 3px rgba(0, 255, 136, 0.1);
}

.input-field:disabled {
  background-color: #1a1a1a;
  color: #666666;
  cursor: not-allowed;
  opacity: 0.7;
}

/* Error state */
.input-error {
  border-color: #ef4444;
}

.input-error:focus {
  border-color: #ef4444;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}

.input-error-message {
  font-size: 0.875rem;
  color: #ef4444;
  margin-top: 0.25rem;
}

/* Success state */
.input-success {
  border-color: #00ff88;
}

.input-success:focus {
  border-color: #00ff88;
  box-shadow: 0 0 0 3px rgba(0, 255, 136, 0.1);
}

.input-success-message {
  font-size: 0.875rem;
  color: #00ff88;
  margin-top: 0.25rem;
}

/* Password input */
.input-field[type="password"] {
  font-family: monospace;
  letter-spacing: 0.125em;
}

/* Email input */
.input-field[type="email"] {
  text-transform: lowercase;
}

/* Number input */
.input-field[type="number"]::-webkit-outer-spin-button,
.input-field[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.input-field[type="number"] {
  -moz-appearance: textfield;
}

/* Date input */
.input-field[type="date"] {
  position: relative;
  color-scheme: dark;
}

.input-field[type="date"]::-webkit-calendar-picker-indicator {
  background: transparent;
  bottom: 0;
  color: transparent;
  cursor: pointer;
  height: auto;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: auto;
  filter: invert(1);
}

.input-field[type="date"]::-webkit-datetime-edit {
  color: #ffffff;
}

.input-field[type="date"]::-webkit-datetime-edit-fields-wrapper {
  background: transparent;
}

.input-field[type="date"]::-webkit-datetime-edit-text {
  color: #ffffff;
  padding: 0 0.1em;
}

.input-field[type="date"]::-webkit-datetime-edit-month-field,
.input-field[type="date"]::-webkit-datetime-edit-day-field,
.input-field[type="date"]::-webkit-datetime-edit-year-field {
  color: #ffffff;
  background: transparent;
}

/* Firefox date input */
.input-field[type="date"]::-moz-placeholder {
  color: #888888;
}

.input-field[type="date"]::-webkit-input-placeholder {
  color: #888888;
}

/* Light theme variant for admin pages */
.input-field.light-theme {
  background-color: #ffffff;
  color: #1e293b;
  border-color: #d1d5db;
}

.input-field.light-theme::placeholder {
  color: #9ca3af;
}

.input-field.light-theme:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.input-field.light-theme:disabled {
  background-color: #f9fafb;
  color: #6b7280;
}

.input-label.light-theme {
  color: #374151;
}

/* Date input light theme */
.input-field.light-theme[type="date"] {
  color-scheme: light;
}

.input-field.light-theme[type="date"]::-webkit-datetime-edit {
  color: #1e293b;
}

.input-field.light-theme[type="date"]::-webkit-datetime-edit-text {
  color: #1e293b;
}

.input-field.light-theme[type="date"]::-webkit-datetime-edit-month-field,
.input-field.light-theme[type="date"]::-webkit-datetime-edit-day-field,
.input-field.light-theme[type="date"]::-webkit-datetime-edit-year-field {
  color: #1e293b;
  background: transparent;
}

.input-field.light-theme[type="date"]::-webkit-calendar-picker-indicator {
  filter: none;
}

/* Responsive */
@media (max-width: 640px) {
  .input-field {
    padding: 0.875rem 1rem;
    font-size: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/Input.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,gCAAgC;EAChC,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;EAGE,cAAc;EACd,uBAAuB;AACzB;;AAEA,uBAAuB;AACvB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,eAAe;EACjB;AACF","sourcesContent":[".input-container {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  width: 100%;\n}\n\n.input-label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #cccccc;\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.input-required {\n  color: #ff4444;\n  font-weight: 600;\n}\n\n.input-field {\n  padding: 0.75rem 1rem;\n  border: 2px solid #444444;\n  border-radius: 0.5rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  color: #ffffff;\n  background-color: #2a2a2a;\n  transition: all 0.2s ease-in-out;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.input-field::placeholder {\n  color: #888888;\n}\n\n.input-field:focus {\n  outline: none;\n  border-color: #00ff88;\n  box-shadow: 0 0 0 3px rgba(0, 255, 136, 0.1);\n}\n\n.input-field:disabled {\n  background-color: #1a1a1a;\n  color: #666666;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n/* Error state */\n.input-error {\n  border-color: #ef4444;\n}\n\n.input-error:focus {\n  border-color: #ef4444;\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);\n}\n\n.input-error-message {\n  font-size: 0.875rem;\n  color: #ef4444;\n  margin-top: 0.25rem;\n}\n\n/* Success state */\n.input-success {\n  border-color: #00ff88;\n}\n\n.input-success:focus {\n  border-color: #00ff88;\n  box-shadow: 0 0 0 3px rgba(0, 255, 136, 0.1);\n}\n\n.input-success-message {\n  font-size: 0.875rem;\n  color: #00ff88;\n  margin-top: 0.25rem;\n}\n\n/* Password input */\n.input-field[type=\"password\"] {\n  font-family: monospace;\n  letter-spacing: 0.125em;\n}\n\n/* Email input */\n.input-field[type=\"email\"] {\n  text-transform: lowercase;\n}\n\n/* Number input */\n.input-field[type=\"number\"]::-webkit-outer-spin-button,\n.input-field[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.input-field[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n/* Date input */\n.input-field[type=\"date\"] {\n  position: relative;\n  color-scheme: dark;\n}\n\n.input-field[type=\"date\"]::-webkit-calendar-picker-indicator {\n  background: transparent;\n  bottom: 0;\n  color: transparent;\n  cursor: pointer;\n  height: auto;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: auto;\n  filter: invert(1);\n}\n\n.input-field[type=\"date\"]::-webkit-datetime-edit {\n  color: #ffffff;\n}\n\n.input-field[type=\"date\"]::-webkit-datetime-edit-fields-wrapper {\n  background: transparent;\n}\n\n.input-field[type=\"date\"]::-webkit-datetime-edit-text {\n  color: #ffffff;\n  padding: 0 0.1em;\n}\n\n.input-field[type=\"date\"]::-webkit-datetime-edit-month-field,\n.input-field[type=\"date\"]::-webkit-datetime-edit-day-field,\n.input-field[type=\"date\"]::-webkit-datetime-edit-year-field {\n  color: #ffffff;\n  background: transparent;\n}\n\n/* Firefox date input */\n.input-field[type=\"date\"]::-moz-placeholder {\n  color: #888888;\n}\n\n.input-field[type=\"date\"]::-webkit-input-placeholder {\n  color: #888888;\n}\n\n/* Light theme variant for admin pages */\n.input-field.light-theme {\n  background-color: #ffffff;\n  color: #1e293b;\n  border-color: #d1d5db;\n}\n\n.input-field.light-theme::placeholder {\n  color: #9ca3af;\n}\n\n.input-field.light-theme:focus {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.input-field.light-theme:disabled {\n  background-color: #f9fafb;\n  color: #6b7280;\n}\n\n.input-label.light-theme {\n  color: #374151;\n}\n\n/* Date input light theme */\n.input-field.light-theme[type=\"date\"] {\n  color-scheme: light;\n}\n\n.input-field.light-theme[type=\"date\"]::-webkit-datetime-edit {\n  color: #1e293b;\n}\n\n.input-field.light-theme[type=\"date\"]::-webkit-datetime-edit-text {\n  color: #1e293b;\n}\n\n.input-field.light-theme[type=\"date\"]::-webkit-datetime-edit-month-field,\n.input-field.light-theme[type=\"date\"]::-webkit-datetime-edit-day-field,\n.input-field.light-theme[type=\"date\"]::-webkit-datetime-edit-year-field {\n  color: #1e293b;\n  background: transparent;\n}\n\n.input-field.light-theme[type=\"date\"]::-webkit-calendar-picker-indicator {\n  filter: none;\n}\n\n/* Responsive */\n@media (max-width: 640px) {\n  .input-field {\n    padding: 0.875rem 1rem;\n    font-size: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
